import {JWTTOKEN, ACTIVE_REGION} from './userTypes'
const initialState = {
    token: '',
    name: '',
    region: 'active'
}

export const userReducer:any = (state=initialState,action:any) => {
    switch(action.type) {
        case JWTTOKEN: 
            const jwttoken = action.accountInfo.jwtIdToken;
            const accountName = action.accountInfo.account.name;
                return {
                    ...state,
                    token: jwttoken,
                    name:accountName
                }
        case ACTIVE_REGION:
            return {
                ...state,
                region: action.activatedRegion
            }
            
        default: return state
    }
}